import styles from './LoadingBucket.module.scss';

interface Props {
  count?: number;
}

export default function LoadingBucket({ count = 4 }: Props) {
  return (
    <div className={styles.loadingGrid}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.loadingCell}>
          <div>
            <div className={styles.skeletonImage} />
            <div className={styles.skeletonTitle} />
            <div className={styles.skeletonLine} />
            <div className={styles.skeletonLine} />
          </div>
        </div>
      ))}
    </div>
  );
}
